import axios from 'axios';
import each from 'lodash/each';

import config from 'config';
import {PaginatableCollection} from 'domains/base/collections';

export default {
    state: {
        customers: new PaginatableCollection(),
        currentCustomer: null,
        sort: 'created_at',
        sortDirection: 'DESC',
        searchObject: {},
    },
    actions: {
        async getCustomer({rootState, state, commit}) {
            let response = await axios.get(`${config.API_DOMAIN}${rootState.user._links.customers.get.replace('{customerId}', rootState.route.params.id)}`);

            commit('updateState', {state, property: 'currentCustomer', value: response.data});

            return response;
        },
        async getCustomers({rootState, state, commit}) {
            let params = [`page=${rootState.route.params.page - 1}`, `sort=${state.sort},${state.sortDirection}`];

            each(state.searchObject, (value, key) => {
                if (value) {
                    params.push(`${key}=${value}|like`);
                }
            });

            let response = await axios.get(`${config.API_DOMAIN}${rootState.user._links.customers.search}?${params.join('&')}`);

            commit('setPaginatableCollection', {paginatableCollection: state.customers, data: response.data});

            return response;
        },
    },
    mutations: {},
};
